// Evenly-spaced, round-number Y ticks for the very tight meter-factor domains our
// charts use (often < 0.001 wide). Left to itself, Recharts divides an explicit
// domain (with allowDataOverflow) into arbitrary evenly-spaced VALUES, which then
// collide/mislabel after 4-decimal rounding — so a gridline labeled "1.0400" may
// actually sit at 1.03998, making data points look misaligned with the axis.
// Generating our own "nice" ticks keeps every label exact and evenly spaced, and
// the returned [first, last] makes a clean stable domain.
// minStep defaults to 0.0001 — meter factors are shown to 4 decimals, so a smaller
// step would produce gridlines with duplicate labels. Clamp so every tick is distinct.
export function niceTicks(min: number, max: number, target = 5, minStep = 0.0001): number[] {
  if (!isFinite(min) || !isFinite(max)) return [];
  if (min === max) { min -= 0.0005; max += 0.0005; }
  const range = max - min;
  const rawStep = range / Math.max(1, target);
  const mag = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const norm = rawStep / mag;
  const step = Math.max(minStep, (norm < 1.5 ? 1 : norm < 3 ? 2 : norm < 7 ? 5 : 10) * mag);
  const start = Math.floor(min / step) * step;
  const end = Math.ceil(max / step) * step;
  const ticks: number[] = [];
  // toFixed(10) trims binary-float dust (e.g. 1.0399999999) before it reaches labels.
  for (let v = start; v <= end + step * 0.5; v += step) {
    ticks.push(Number(v.toFixed(10)));
  }
  return ticks;
}
